import React, { useEffect, useMemo, useState } from "react";
import { FaCloud, FaCheckCircle, FaMobileAlt } from "react-icons/fa";
import i18n from "../i18n";

function Card({ icon, title, description, link, ctaText }) {
  const handleClick = (e) => {
    e.preventDefault();

    const target = document.querySelector("#solutions");
    if (target) {
      target.scrollIntoView({ behavior: "smooth" });
      window.history.pushState(null, "", link);
    }
  };

  return (
    <a
      href={link}
      onClick={handleClick}
      className="bg-white shadow-[0_4px_12px_rgba(0,0,0,0.06)] rounded-2xl px-4 py-8 flex flex-col items-center text-center max-w-xs w-full transition-transform hover:scale-105"
    >
      <div className="mb-4 w-12 h-12 flex items-center justify-center rounded-full bg-gray-100 text-2xl">
        {icon}
      </div>
      <h3 className="text-xl font-bold text-gray-900 mb-2">{title}</h3>
      <p className="text-gray-500 text-base mb-4">{description}</p>
      <span className="text-blue-600 border border-blue-600 rounded-lg px-4 py-2 text-sm font-medium flex items-center gap-2 hover:bg-blue-50 transition">
        {ctaText} <span className="text-lg">→</span>
      </span>
    </a>
  );
}

const HeroSection = () => {
  const [langTick, setLangTick] = useState(0);

  useEffect(() => {
    const onLang = () => setLangTick((x) => x + 1);
    i18n.on("languageChanged", onLang);
    return () => i18n.off("languageChanged", onLang);
  }, []);

  const scrollToSolutions = () => {
    const target = document.querySelector("#solutions");
    if (target) {
      target.scrollIntoView({ behavior: "smooth" });
      window.history.pushState(null, "", "/test#migration");
    }
  };

  const tr = useMemo(() => {
    void langTick;

    return {
      h1Line1: i18n.t("hero.title.line1"),
      h1Line2: i18n.t("hero.title.line2"),
      button: i18n.t("hero.button"),
      cta: i18n.t("hero.cardCta"),
      cards: [
        {
          link: "/test#migration",
          icon: <FaCloud className="text-indigo-500 text-2xl" />,
          title: i18n.t("hero.cards.migration.title"),
          description: i18n.t("hero.cards.migration.description"),
        },
        {
          link: "/test#automation",
          icon: <FaCheckCircle className="text-indigo-500 text-2xl" />,
          title: i18n.t("hero.cards.automation.title"),
          description: i18n.t("hero.cards.automation.description"),
        },
        {
          link: "/test#app-dev",
          icon: <FaMobileAlt className="text-indigo-500 text-2xl" />,
          title: i18n.t("hero.cards.appdev.title"),
          description: i18n.t("hero.cards.appdev.description"),
        },
      ],
    };
  }, [langTick]);

  return (
    <div className="relative bg-gradient-to-b from-[#050825] to-[#060A40] text-white py-16 px-6 md:px-12 lg:px-24">
      <div className="max-w-7xl mx-auto text-center">
        <h1 className="text-6xl md:text-8xl font-bold mt-10 md:mt-20">
          {tr.h1Line1} <br />
          <span className="text-gray-400">{tr.h1Line2}</span>
        </h1>

        <button
          onClick={scrollToSolutions}
          className="inline-block mt-6 mb-20 px-6 py-3 bg-blue-600 rounded-full text-white text-lg font-medium hover:bg-blue-800 transition"
          type="button"
        >
          {tr.button}
        </button>
      </div>

      <div className="relative z-10 mt-4 flex justify-center">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-5xl mx-auto">
          {tr.cards.map((c) => (
            <Card
              key={c.link}
              link={c.link}
              icon={c.icon}
              title={c.title}
              description={c.description}
              ctaText={tr.cta}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default HeroSection;


































